import React from 'react';
import styled from 'styled-components';
import { Tooltip } from '@mui/material';

function StatusBubbles(props) {
  const { tag, overdue, scheduled } = props;
  const bubble = (
    <StatusBubble name={tag.name} overdue={overdue} scheduled={scheduled}>
      <StatusBubblesText>{tag.name}</StatusBubblesText>
    </StatusBubble>
  );
  return tag.tooltipTitle ? (
    <Tooltip
      title={tag.tooltipTitle}
      placement="bottom"
      enterDelay={300}
      PopperProps={{
        sx: { zIndex: 1500 },
        modifiers: [{ name: 'offset', options: { offset: [0, 2] } }],
      }}
    >
      <TooltipTrigger>{bubble}</TooltipTrigger>
    </Tooltip>
  ) : (
    bubble
  );
}

const TooltipTrigger = styled.span`
  display: inline-block;
  min-width: 0;
  max-width: 100%;
`;

const StatusBubble = styled.article`
  display: flex;
  min-width: 0;
  max-width: 100%;
  align-items: center;
  gap: 10px;
  padding: 3px 8px;
  position: relative;
  background-color: ${(props) =>
    props.name === 'Community' ? 'var(--blue-chalk)' : '#FFFFFF'};
  border-radius: 11.5px;
  border: 1px solid;
  border-color: ${(props) =>
    props.name === 'Community'
      ? props.overdue
        ? 'var(--royal-purple)'
        : 'var(--blue-chalk)'
      : '#DEC7FF'};
`;

const StatusBubblesText = styled.div`
  color: ${(props) =>
    props.name === 'Community'
      ? 'var(--horses-neck)'
      : 'rgba(161, 84, 234, 1)'};
  font-family: var(--font-family-ibm_plex_sans);
  font-size: 13px;
  font-weight: 500;
  font-style: normal;
  position: relative;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
  letter-spacing: 0;
  line-height: normal;
`;

export default StatusBubbles;
